export default {
    leaveOnsite: 'ลา / นอกสถานที่',
    leaveType: 'ประเภทของการลา',
    selectType: '- เลือกประเภทการลา -',
    choice: 'เลือก',
    singleDay: 'วันเดียว',
    range: 'ช่วงเวลา',
    startDate: 'วันที่เริ่มต้น',
    endDate: 'วันที่สิ้นสุด',
    time: 'เวลา',
    selectPeriodType: '- เลือกประเภทช่วงเวลา -',
    attachFile: 'แนบไฟล์',
    fileImage: 'ไฟล์ / รูปภาพ',
    reason: 'เหตุผล',
    reasonMsg: 'รายละเอียดการลาของคุณ',
    cancel: 'ยกเลิก',
    submit: 'ส่ง',
    fieldRequired: 'กรุณากรอกข้อมูล',
    fieldLessThanCharacters: 'ช่องนี้รองรับตัวอักษรไม่เกิน 255 ตัวอักษร',
    msgSuccessSingleDay: 'คำขอของคุณ วันที่ $startDate สำเร็จ',
    msgSuccessRange: 'คำขอของคุณ วันที่ $startDate ถึง $endDate สำเร็จ',
    cannotGetLineId: 'เกิดข้อผิดพลาด',
    approve: 'อนุมัติ',
    reject: 'ปฏิเสธ',
    back: 'ย้อนกลับ'
}
